<div *ngIf="state.job && state.canCancel" class="small-icon-button flex justify-center items-center">
  <mat-spinner class="w-1/2 h-1/2" [diameter]="15" *ngIf="state.cancellationInProgress"></mat-spinner>
  <button
    *ngIf="!state.cancellationInProgress"
    class="w-full h-full"
    mat-icon-button
    color="warn"
    (click)="cancelJob(jobRequestId, state.job.path)"
  >
    <fa-icon class="fs-1 bad-text" [icon]="['fal', 'stop-circle']"></fa-icon>
  </button>
</div>
